<template>
  <div class="detail-showcase">
    <NavbarComp />

    <div class="container mt-4">
      <img src="../assets/detailshowcase1.png" alt="" />
      <h1>Lorem ipsum dolor sit amet</h1>
      <h5>Terry Dias <span>&#40;Web Development&#41;</span></h5>
      <h2>Summary</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eu, rutrum
        fermentum ut orci blandit praesent nibh. Habitant tristique sed aliquam
        dolor pretium. Felis dolor non pulvinar ultricies quis urna tincidunt.
        A, donec nulla tortor turpis phasellus risus etiam sed. In augue
        ultricies magna mi id tincidunt. Placerat tempor, malesuada tincidunt mi
        aliquet lacus eleifend. Sit semper quis dolor id nibh nisi, consectetur.
        Pharetra rhoncus arcu condimentum felis, nec amet, dignissim id mattis.
        A urna, nisi, est egestas nisl eget ullamcorper egestas. Sed ut eu, in
        auctor id ullamcorper. Nam scelerisque arcu, ipsum nunc. Tellus ut
        vulputate adipiscing egestas iaculis sit risus egestas.
      </p>
      <h2>Description</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eu, rutrum
        fermentum ut orci blandit praesent nibh. Habitant tristique sed aliquam
        dolor pretium. Felis dolor non pulvinar ultricies quis urna tincidunt.
        A, donec nulla tortor turpis phasellus risus etiam sed. In augue
        ultricies magna mi id tincidunt. Placerat tempor, malesuada tincidunt mi
        aliquet lacus eleifend. Sit semper quis dolor id nibh nisi, consectetur.
        Pharetra rhoncus arcu condimentum felis, nec amet, dignissim id mattis.
        A urna, nisi, est egestas nisl eget ullamcorper egestas. Sed ut eu, in
        auctor id ullamcorper. Nam scelerisque arcu, ipsum nunc. Tellus ut
        vulputate adipiscing egestas iaculis sit risus egestas.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eu, rutrum
        fermentum ut orci blandit praesent nibh. Habitant tristique sed aliquam
        dolor pretium. Felis dolor non pulvinar ultricies quis urna tincidunt.
        A, donec nulla tortor turpis phasellus risus etiam sed. In augue
        ultricies magna mi id tincidunt. Placerat tempor, malesuada tincidunt mi
        aliquet lacus eleifend. Sit semper quis dolor id nibh nisi, consectetur.
        Pharetra rhoncus arcu condimentum felis, nec amet, dignissim id mattis.
        A urna, nisi, est egestas nisl eget ullamcorper egestas. Sed ut eu, in
        auctor id ullamcorper. Nam scelerisque arcu, ipsum nunc. Tellus ut
        vulputate adipiscing egestas iaculis sit risus egestas.
      </p>
    </div>

    <FooterComp />
  </div>
</template>

<script>
import NavbarComp from "../components/NavbarComp.vue";
import FooterComp from "../components/FooterComp.vue";
export default {
  name: "DetailShowcase",
  components: {
    NavbarComp,
    FooterComp,
  },
};
</script>

<style>
.detail-showcase .container {
  box-sizing: border-box;
}
.detail-showcase .container img {
  width: 100%;
  margin-bottom: 40px;
}
.detail-showcase .container h1 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 38px;
  line-height: 130%;
  letter-spacing: 0.005em;
  color: #ff5400;
}
.detail-showcase .container h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0.005em;
  color: #023047;
}
.detail-showcase .container span {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0.005em;
  color: #023047;
}
.detail-showcase .container h2 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 38px;
  line-height: 130%;
  letter-spacing: 0.005em;
  color: #ff5400;
  margin-top: 60px;
}
.detail-showcase .container p {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0.005em;
  color: #000000;
}

@media only screen and (max-width: 500px) {
  .detail-showcase .container img {
    margin-top: 50px;
  }
  .detail-showcase .container h1 {
    font-size: 16px;
  }
  .detail-showcase .container h5 , .detail-showcase .container span{
    font-size: 14px;
  }
  .detail-showcase .container h2 {
    margin-top: 20px;
    font-size: 14px;
  }
  .detail-showcase .container p {
    font-size: 12px;
    text-align: justify;
  }
}
</style>